module.exports = __webpack_public_path__ + "static/media/conto-inicial.a76f9bd4.mp3";